
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/advertisers",
      function () {
        return require("private-next-pages/advertisers/index.js");
      }
    ]);
  